import {types} from 'mobx-state-tree';
import Category from './category';

const ALL_CONTENT_TYPES = ['VIDEO', 'LINK', 'DOCUMENT', 'TOP_BANNER', 'BOTTOM_BANNER', 'DIRECT_LINK']
/* Notes:
"type", "mobileImage", and "category" are not editable/not used.
ORDER MATTERS to the display order of the fields in the form. */
const FIELD_TO_CONTENT_MAPPING = {
  fileName: ['VIDEO', 'DOCUMENT', 'TOP_BANNER', 'BOTTOM_BANNER', 'DIRECT_LINK'],
  caption: ['VIDEO'],
  image: ['VIDEO', 'LINK'],
  imageAltText: ['VIDEO', 'LINK'],
  href: ['LINK', 'DIRECT_LINK'],
  title: ALL_CONTENT_TYPES,
  lengthInSeconds: ['VIDEO'],
  description: ALL_CONTENT_TYPES,
  keywords: ['VIDEO','DOCUMENT']
}

const Authorization = types.model('Authorization', {
  role: types.string,
  isPremierUser: types.maybeNull(types.boolean)
});

const ContentItem = types.model('ContentItem', {
  id: types.identifier,
  title: types.maybeNull(types.string),
  type: types.enumeration(['VIDEO', 'DOCUMENT', 'LINK', 'TOP_BANNER', 'BOTTOM_BANNER', 'DIRECT_LINK']),
  description: types.maybeNull(types.string),
  category: types.maybeNull(types.reference(Category)),
  image: types.maybeNull(types.string),
  imageAltText: types.maybeNull(types.string),
  fileName: types.maybeNull(types.string),
  caption: types.maybeNull(types.string),
  href: types.maybeNull(types.string),
  lengthInSeconds: types.optional(types.number, 0),
  fieldList: types.optional(types.array(types.string), []),
  authorizations: types.array(Authorization),
  keywords: types.maybeNull(types.string)
})
.actions(self => ({
  afterCreate() {
    self.setFieldList();
  },

  setFieldList() {
    try {
      self.fieldList = Object.entries(FIELD_TO_CONTENT_MAPPING)
        .filter(keyPair => {
          const allowedContentTypes = keyPair[1];
          return allowedContentTypes && allowedContentTypes.indexOf(self.type) > -1;
        })
        .map(keyPair => keyPair[0]);
    } catch(e) {
      self.fieldList = [];
    }
  },

  changeProperty(key, value) {
    self[key] = value;
  },

  addAuthorization(value) {
    //const snapshot = JSON.parse(JSON.stringify(self));
    self.authorizations = value;
    //applySnapshot(self, snapshot);

  },

  removeAuthorization() {

  },

  getFieldInfo(key) {
    return self.fieldToInputMapping[key] || {}
  }
}))
.views((self) => ({
  get isValid() {
    let isValid = true;

    self.fieldList.forEach(key => {
      if(!self[key]&& key!='keywords') {
        console.log('Missing value for ' + key + ': ' + self[key])
        isValid = false;
      }
    })

    if(self.authorizations.length === 0) {
      console.log('Missing value for authorizations: ' + self.authorizations)
      isValid = false;
    }
    return isValid;
  },

  get authorizationsAsStrings() {
    return self.authorizations.map(authorization => JSON.stringify({role: authorization.role, isPremierUser: authorization.isPremierUser}))
  },

  get fieldToInputMapping() {
    const imageDropzoneLabel = self.type === 'VIDEO' ? 'Poster Image' : 'Image';
    const imageHelperText = self.type === 'VIDEO' ? 'PNG only, size 464wx260h px.' : 'PNG only.';
    const titleLabel = self.type === 'VIDEO' ? 'Video Title' : 'Content Title';

    let fileName;
    if(self.type === 'VIDEO') {
      fileName = {
        type: 'DROPZONE',
        labelText: 'Video File',
        helperText: 'MP4 only.',
        allowedExtensions: ['mp4'],
        contentType: 'video/mp4'
      }
    } else {
      fileName = {
        type: 'DROPZONE',
        labelText: 'Downloadable File',
        helperText: 'PDF only.',
        allowedExtensions: ['pdf'],
        contentType: 'application/octet-stream'
      }
    }

    return {
      href: {type: 'TEXT_WEBSITE', labelText: 'URL', helperText: 'Must be a valid web address.', errorMessage: 'Please enter a valid URL.'},
      fileName,
      caption: {type: 'DROPZONE', labelText: 'Transcript File', helperText: 'VTT only.', allowedExtensions: ['vtt'], contentType: 'application/octet-stream'},
      title: {type: 'TEXT_STANDARD', labelText: titleLabel, charLimit: 60, helperText: 'Max 60 characters.', errorMessage: 'Please enter a valid title.'},
      lengthInSeconds: {type: 'TEXT_NUMERIC', labelText: 'Duration in Seconds', helperText: 'Digits [0-9] only.', errorMessage: 'Please enter a valid duration.'},
      description: {type: 'TEXT_STANDARD', labelText: 'Description', charLimit: 1000, helperText: 'Max 1000 characters.', errorMessage: 'Please enter a valid description.'},
      image: {type: 'DROPZONE', labelText: imageDropzoneLabel, helperText: imageHelperText, allowedExtensions: ['png'], contentType: 'image/png', isImageUpload: true},
      imageAltText: {type: 'TEXT_STANDARD', labelText: 'Image Alt-Text', charLimit: 175, helperText: 'Max 175 characters.', errorMessage: 'Please enter valid alt-text.'},
      keywords: {type: 'TEXT_STANDARD', labelText: 'Keywords', charLimit: 250,  helperText: 'Max 250 characters.', errorMessage: 'Please enter valid keywords'}
    }
  }
}))

export default ContentItem;
